<script lang="ts">
  let {
    trackType,
    youtubeId = null,
    soundcloudUrl = null,
    tiktokUrl = null,
    uploadUrl = null,
    uploadImageUrl = null,
  }: {
    trackType: string;
    youtubeId?: string | null;
    soundcloudUrl?: string | null;
    tiktokUrl?: string | null;
    uploadUrl?: string | null;
    uploadImageUrl?: string | null;
  } = $props();
</script>

<div class="player-embed">
  {#if trackType === 'youtube' && youtubeId}
    <iframe
      src="https://www.youtube.com/embed/{youtubeId}?autoplay=0&rel=0"
      title="YouTube player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  {:else if trackType === 'soundcloud' && soundcloudUrl}
    <iframe
      src="https://w.soundcloud.com/player/?url={encodeURIComponent(
        soundcloudUrl,
      )}&color=%2300e5ff&auto_play=false&show_artwork=true"
      title="SoundCloud player"
      frameborder="0"
      allow="autoplay"
    ></iframe>
  {:else if trackType === 'tiktok' && tiktokUrl}
    <iframe
      src="https://www.tiktok.com/embed/v2/{tiktokUrl.split('/').pop()}"
      title="TikTok player"
      frameborder="0"
      allow="autoplay"
      allowfullscreen
    ></iframe>
  {:else if trackType === 'upload' && uploadUrl}
    <div class="upload-player">
      {#if uploadImageUrl}
        <img src={uploadImageUrl} alt="" class="upload-art" />
      {/if}
      <audio controls src={uploadUrl}></audio>
    </div>
  {:else}
    <div class="no-player">No player available</div>
  {/if}
</div>

<style>
  .player-embed {
    width: 100%;
    aspect-ratio: 16/9;
    border-radius: var(--radius);
    overflow: hidden;
    background: #000;
  }
  .player-embed iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  .upload-player {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    background: var(--surface);
  }
  .upload-art {
    max-height: 12rem;
    border-radius: var(--radius-sm);
  }
  .upload-player audio {
    width: 80%;
  }
  .no-player {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
  }
</style>
